

const firebaseConfig = {
    apiKey: "AIzaSyDYj7-Y5IGl8b6_UHedKO94rI4S9JYFCkc",
    authDomain: "assinment-10-1271d.firebaseapp.com",
    projectId: "assinment-10-1271d",
    storageBucket: "assinment-10-1271d.appspot.com",
    messagingSenderId: "650268601449",
    appId: "1:650268601449:web:724c7a6bdafc9011e046f8"
  };

  
  export default firebaseConfig;